import { render } from "./edit-staff.vue?vue&type=template&id=67c37bb1"
import script from "./edit-staff.vue?vue&type=script&lang=js"
export * from "./edit-staff.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__